import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Logo } from './Logo';
const PHONE = '586-203-3701';
const EMAIL = 'MoceriRS@gmail.com';
export function Footer() {
  return <footer className="bg-[#0f1620] text-slate-300 pt-14 pb-24 md:pb-10" data-id="element-97" data-mp="32o4ao9g4a660">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-98" data-mp="32lrnnhvi55m3">
        <div className="grid md:grid-cols-3 gap-10 items-start" data-id="element-99" data-mp="36q94p9ah94t6">
          <div className="flex flex-col items-center md:items-start" data-id="element-100" data-mp="3ueik9th3kwbv">
            <Logo size={80} className="mb-3" data-id="element-101" data-mp="3ud7gvurkdqla" />
            <p className="font-display italic text-2xl text-white mb-1" data-id="element-102" data-mp="37o5ytxdtvcu">
              Quality That's Through The Roof
            </p>
            <p className="text-sm text-slate-400 text-center md:text-left" data-id="element-103" data-mp="3le2kov3h69ca">
              Moceri Residential Services LLC — Michigan's trusted residential
              roofing company.
            </p>
          </div>

          <div className="text-center md:text-left" data-id="element-104" data-mp="2a1jkhcbdo041">
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-105" data-mp="2ez1kuebbx70f">
              Contact
            </h4>
            <ul className="space-y-3" data-id="element-106" data-mp="3l9sgay2igglb">
              <li data-id="element-107" data-mp="3gaz3z8yymvmq">
                <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-108" data-mp="3gbingu49ds2v">
                  <Phone className="w-4 h-4 text-[#2DB8E0]" data-id="element-109" data-mp="3q8dhazpl74at" /> {PHONE}
                </a>
              </li>
              <li data-id="element-110" data-mp="81yxwl8ju251">
                <a href={`mailto:${EMAIL}`} className="inline-flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-111" data-mp="81fpbv4sgq3o">
                  <Mail className="w-4 h-4 text-[#2DB8E0]" data-id="element-112" data-mp="hrs9hm8oyh9a" /> {EMAIL}
                </a>
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-113" data-mp="cv1r2s9ez9kp">
                <MapPin className="w-4 h-4 text-[#2DB8E0]" data-id="element-114" data-mp="qt04nvfwv1z5" /> Serving all of
                Michigan
              </li>
            </ul>
          </div>

          <div className="text-center md:text-left" data-id="element-115" data-mp="mtrcgv0irc5p">
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-116" data-mp="tvmp5eeoaakb">
              Services on This Page
            </h4>
            <ul className="space-y-2 text-sm" data-id="element-117" data-mp="yupnyh427kju">
              <li data-id="element-118" data-mp="13tkb1v927v9r">Shingle Roof Replacement</li>
              <li data-id="element-119" data-mp="13rpu0s0wsnay">Asphalt Shingle Installation</li>
              <li data-id="element-120" data-mp="18jr2s3yvbvw8">Storm Damage Roof Replacement</li>
              <li data-id="element-121" data-mp="18lbuzmxpn2qx">Free Roof Inspections</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500" data-id="element-122" data-mp="1cl2t6bpkgl5h">
          <p data-id="element-123" data-mp="1mk1rp1gmb0er">
            &copy; {new Date().getFullYear()} Moceri Residential Services LLC.
            All rights reserved.
          </p>
          <p data-id="element-124" data-mp="1rhk3r0pxlvqz">Licensed & Insured in the State of Michigan</p>
        </div>
      </div>
    </footer>;
}